// Host-based routing helper.
// Set REACT_APP_ADMIN_HOST="app.msonlinetravel.com" in production .env
// to expose admin/agency routes only on that subdomain.
// Falls back to single-host mode (everything available) when not set.

const ADMIN_HOST = (process.env.REACT_APP_ADMIN_HOST || "").toLowerCase().trim();

export function isAdminHost() {
    if (!ADMIN_HOST) return true; // single-host: admin available everywhere
    if (typeof window === "undefined") return true;
    return window.location.hostname.toLowerCase() === ADMIN_HOST;
}

export function isPublicHost() {
    if (!ADMIN_HOST) return true; // single-host: public available everywhere
    if (typeof window === "undefined") return true;
    return window.location.hostname.toLowerCase() !== ADMIN_HOST;
}

export const HAS_SPLIT_HOSTS = !!ADMIN_HOST;
